/* TRS QuickStudy (trs-discovery-revamp, W1a). Needs no framework; single-item adds are handled by trs-guide.js.
   - [data-qs-fmt] buttons: switch [data-qs-root] between print and PDF (prices, quick-add, card links)
   - [data-qs-group] chips: show one group of guides or all
   - form[data-qs-add-many="id,id,..."]: add a whole set in one /cart/add.js call; if that fails (a guide is
     sold out) add them one by one and report how many made it
   - [data-qs-flip]: flip the side 1 / side 2 viewer */
(function () {
  if (window.__trsQsJs) return;
  window.__trsQsJs = true;
  var KEY = 'trs-qs-fmt';
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  function setFmt(scope, fmt) {
    scope.setAttribute('data-fmt', fmt);
    scope.querySelectorAll('[data-qs-fmt]').forEach(function (b) {
      var on = b.getAttribute('data-qs-fmt') === fmt;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-href-print]').forEach(function (a) {
      var u = a.getAttribute('data-href-' + fmt);
      if (u) a.setAttribute('href', u);
    });
  }

  function openQuickCart() {
    var icons = document.querySelectorAll('a[data-js-cart-icon]');
    for (var i = 0; i < icons.length; i++) {
      if (icons[i].offsetParent !== null) { icons[i].click(); return; }
    }
  }

  function post(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok; });
  }

  function init() {
    // format toggle (collection page); remember the choice for this visitor
    document.querySelectorAll('.trs-qs-col[data-qs-root]').forEach(function (scope) {
      var saved = null;
      try { saved = window.localStorage.getItem(KEY); } catch (e) {}
      if (saved === 'pdf' || saved === 'print') setFmt(scope, saved);
      scope.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qs-fmt]');
        if (b) {
          var f = b.getAttribute('data-qs-fmt');
          setFmt(scope, f);
          try { window.localStorage.setItem(KEY, f); } catch (e2) {}
          return;
        }
        var g = e.target.closest('[data-qs-group]');
        if (g) {
          var key = g.getAttribute('data-qs-group');
          scope.querySelectorAll('[data-qs-group]').forEach(function (x) {
            var on = x === g;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          scope.querySelectorAll('.qs-group[data-group]').forEach(function (s) {
            s.classList.toggle('is-hidden', key !== 'all' && s.getAttribute('data-group') !== key);
          });
        }
      });
    });

    document.querySelectorAll('[data-qs-flip]').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.classList.toggle('is-flipped');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-qs-add-many]') || !window.fetch) return;
    e.preventDefault();
    var ids = form.getAttribute('data-qs-add-many').split(',').filter(Boolean).map(Number);
    var btn = form.querySelector('button');
    var label = btn && btn.querySelector('.tg-btn__label');
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    post(items).then(function (ok) {
      if (ok) return ids.length;
      // one of them is sold out: add the rest one by one
      var n = 0;
      return ids.reduce(function (p, id) {
        return p.then(function () { return post([{ id: id, quantity: 1 }]).then(function (k) { if (k) n++; }); });
      }, Promise.resolve()).then(function () { return n; });
    }).then(function (n) {
      if (!btn) return;
      btn.classList.remove('is-busy');
      if (n > 0) {
        btn.classList.add('is-added');
        if (label) label.textContent = n === ids.length ? (btn.getAttribute('data-added-text') || 'Added') : ('Added ' + n + ' of ' + ids.length);
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        setTimeout(openQuickCart, 350);
      } else if (label) {
        label.textContent = 'Sold out';
      }
      setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; btn.disabled = false; }, 2800);
    }).catch(function () { form.submit(); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
